<template>
  <span>
    <v-chip v-if="destaque" class="fs-chip" :color="color" :style="`border: 1px solid ${color}`" text-color="white" small>
      <v-avatar left><v-icon>{{ icon }}</v-icon></v-avatar>
      {{ text }}
    </v-chip>

    <v-chip v-else class="fs-chip" :color="color" outlined small>
      <v-avatar left><v-icon>{{ icon }}</v-icon></v-avatar>
      {{ text }}
    </v-chip>
  </span>
</template>

<script>
export default {
  props: {
    text: String,
    color: String,
    icon: String,
    destaque: Boolean
  }
}
</script>

<style scoped>
  .fs-chip {
    padding: 14px 17px 14px 17px !important;
    margin: 5px 0px 1px 0px !important;
    font-size: 12px;
    border-radius: 15px;
    /* width: 100%; */
    width: 255px;
    letter-spacing: .8px;
  }
</style>
